import React from 'react';

function Loading(props) {
    return (
        <div className='loader'>
        </div>
    );
}

export default Loading;